import PropTypes from 'prop-types'
import { capitalizar } from '../../../helpers/textFormatHelpers'

import styles from './Filtros.module.css'

export const RadioInput = ({ onClick, valor, isSelected }) => {
  return (
    <span
      key={valor}
      className={`${styles.crumb} 
        ${isSelected ? styles.selected : ''}`}
      onClick={() => onClick(valor)}
    >
      {capitalizar(valor)}
      {isSelected && (
        <button
          className={styles.closeBtn}
          onClick={(e) => {
            e.stopPropagation()
            onClick('')
          }}
        >
          ✕
        </button>
      )}
    </span>
  )
}

RadioInput.propTypes = {
  onClick: PropTypes.func.isRequired,
  valor: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired
}
